/* eslint-disable max-lines */
import type { SupportCategory, SupportSubcategory, SupportSubcategoryQuestion } from './types';

export const FINANCE_CATEGORIES: SupportCategory[] = [
  { id: 'finance-budget-approvals', label: 'Budget Approvals', departmentId: 'Finance' },
  { id: 'finance-reimbursement', label: 'Reimbursement', departmentId: 'Finance' },
  { id: 'finance-billing', label: 'Billing', departmentId: 'Finance' },
  { id: 'finance-paycheck-workforce', label: 'Paycheck or Workforce', departmentId: 'Finance' },
];

export const FINANCE_SUBCATEGORIES: SupportSubcategory[] = [
  { id: 'finance-budget-marketing-events', label: 'Marketing & Events', categoryId: 'finance-budget-approvals' },
  { id: 'finance-budget-incentives', label: 'Incentives', categoryId: 'finance-budget-approvals' },
  { id: 'finance-budget-travel', label: 'Travel', categoryId: 'finance-budget-approvals' },
  { id: 'finance-budget-other', label: 'Other', categoryId: 'finance-budget-approvals' },
  { id: 'finance-reimbursement-all', label: 'All', categoryId: 'finance-reimbursement' },
  { id: 'finance-billing-discounts', label: 'Discounts Approval', categoryId: 'finance-billing' },
  { id: 'finance-billing-refunds', label: 'Refunds', categoryId: 'finance-billing' },
  { id: 'finance-billing-account-audit', label: 'Account Audit', categoryId: 'finance-billing' },
  {
    id: 'finance-paycheck-workforce-assistance',
    label: 'Workforce Assistance',
    categoryId: 'finance-paycheck-workforce',
  },
  { id: 'finance-paycheck-error', label: 'Paycheck Error', categoryId: 'finance-paycheck-workforce' },
  { id: 'finance-paycheck-questions', label: 'Paycheck Questions', categoryId: 'finance-paycheck-workforce' },
];

export const FINANCE_QUESTIONS: SupportSubcategoryQuestion[] = [
  {
    id: 'q-budget-1',
    subcategoryId: 'finance-budget-marketing-events',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'q-budget-2',
    subcategoryId: 'finance-budget-marketing-events',
    type: 'text',
    label: 'Proposed cost for approval',
    required: true,
  },
  {
    id: 'q-budget-3',
    subcategoryId: 'finance-budget-marketing-events',
    type: 'text',
    label: 'If there was a budget set on planning sheet, what was it?',
    required: true,
  },
  {
    id: 'q-budget-4',
    subcategoryId: 'finance-budget-marketing-events',
    type: 'textarea',
    label: 'Reason on why you are asking for this budget approval',
    required: true,
  },
  {
    id: 'q-budget-incentives-1',
    subcategoryId: 'finance-budget-incentives',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'q-budget-travel-1',
    subcategoryId: 'finance-budget-travel',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'q-budget-incentives-2',
    subcategoryId: 'finance-budget-incentives',
    type: 'text',
    label: 'Proposed cost for approval',
    required: true,
  },
  {
    id: 'q-budget-other-1',
    subcategoryId: 'finance-budget-other',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'q-budget-incentives-3',
    subcategoryId: 'finance-budget-incentives',
    type: 'text',
    label: 'If there was a budget set on planning sheet, what was it?',
    required: true,
  },
  {
    id: 'q-budget-incentives-4',
    subcategoryId: 'finance-budget-incentives',
    type: 'textarea',
    label: 'Reason on why you are asking for this budget approval',
    required: true,
  },
  {
    id: 'q-budget-7',
    subcategoryId: 'finance-budget-travel',
    type: 'text',
    label: 'Proposed cost for approval',
    required: true,
  },
  {
    id: 'q-budget-8',
    subcategoryId: 'finance-budget-travel',
    type: 'text',
    label: 'If there was a budget set on planning sheet, what was it?',
    required: true,
  },
  {
    id: 'q-budget-9',
    subcategoryId: 'finance-budget-travel',
    type: 'textarea',
    label: 'Reason on why you are asking for this budget approval',
    required: true,
  },
  {
    id: 'q-budget-10',
    subcategoryId: 'finance-budget-other',
    type: 'text',
    label: 'Proposed cost for approval',
    required: true,
  },
  {
    id: 'q-budget-11',
    subcategoryId: 'finance-budget-other',
    type: 'text',
    label: 'If there was a budget set on planning sheet, what was it?',
    required: true,
  },
  {
    id: 'q-budget-12',
    subcategoryId: 'finance-budget-other',
    type: 'textarea',
    label: 'Reason on why you are asking for this budget approval',
    required: true,
  },
  {
    id: 'q-reimb-1',
    subcategoryId: 'finance-reimbursement-all',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'q-reimb-2',
    subcategoryId: 'finance-reimbursement-all',
    type: 'textarea',
    label: 'Reason for Reimbursement',
    required: true,
  },
  {
    id: 'q-reimb-3',
    subcategoryId: 'finance-reimbursement-all',
    type: 'select',
    label: 'Did you hyperlink every receipt?',
    required: true,
    options: [
      { value: 'Yes', label: 'Yes' },
      { value: 'No', label: 'No' },
    ],
  },
  {
    id: 'q-reimb-4',
    subcategoryId: 'finance-reimbursement-all',
    type: 'select',
    label: 'Was this approved by your manager?',
    required: true,
    options: [
      { value: 'Yes', label: 'Yes' },
      { value: 'No', label: 'No' },
    ],
  },
  {
    id: 'q-reimb-5',
    subcategoryId: 'finance-reimbursement-all',
    type: 'textarea',
    label: 'Add the link to the reimbursement template that you have created below',
    required: true,
    link: {
      url: 'https://docs.google.com/spreadsheets/d/1Nyd68RrO-H4G7G9mZpA-y6hMSLoGAn_8/edit?usp=sharing&rtpof=true&sd=true',
      label: 'Make a copy of the blank reimbursement template',
    },
  },
  {
    id: 'q-reimb-6',
    subcategoryId: 'finance-reimbursement-all',
    type: 'text',
    label: 'Total Amount to Reimburse',
    required: true,
  },
  {
    id: 'q-bill-disc-1',
    subcategoryId: 'finance-billing-discounts',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'q-bill-disc-2',
    subcategoryId: 'finance-billing-discounts',
    type: 'text',
    label: 'Child Name',
    required: true,
  },
  {
    id: 'q-bill-disc-3',
    subcategoryId: 'finance-billing-discounts',
    type: 'text',
    label: 'Parent Name',
    required: true,
  },
  {
    id: 'q-bill-disc-4',
    subcategoryId: 'finance-billing-discounts',
    type: 'text',
    label: 'Proposed Discount Amount',
    required: true,
  },
  {
    id: 'q-bill-disc-5',
    subcategoryId: 'finance-billing-discounts',
    type: 'text',
    label: 'Length of Discount',
    required: true,
  },
  {
    id: 'q-bill-disc-6',
    subcategoryId: 'finance-billing-discounts',
    type: 'date',
    label: 'End Date Of Discount',
    required: true,
  },
  {
    id: 'q-bill-disc-7',
    subcategoryId: 'finance-billing-discounts',
    type: 'textarea',
    label: 'Reason for Discount',
    required: true,
  },
  {
    id: 'q-bill-disc-8',
    subcategoryId: 'finance-billing-discounts',
    type: 'file',
    label: 'Select a file',
    required: false,
  },
  {
    id: 'q-bill-ref-1',
    subcategoryId: 'finance-billing-refunds',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'q-bill-ref-2',
    subcategoryId: 'finance-billing-refunds',
    type: 'text',
    label: 'Child Name',
    required: true,
  },
  {
    id: 'q-bill-ref-3',
    subcategoryId: 'finance-billing-refunds',
    type: 'text',
    label: 'Parent Name',
    required: true,
  },
  {
    id: 'q-bill-ref-4',
    subcategoryId: 'finance-billing-refunds',
    type: 'text',
    label: 'Proposed Refund Amount',
    required: true,
  },
  {
    id: 'q-bill-ref-5',
    subcategoryId: 'finance-billing-refunds',
    type: 'date',
    label: 'Date Of Refund',
    required: true,
  },
  {
    id: 'q-bill-ref-6',
    subcategoryId: 'finance-billing-refunds',
    type: 'textarea',
    label: 'Reason for Refund',
    required: true,
  },
  {
    id: 'q-bill-ref-7',
    subcategoryId: 'finance-billing-refunds',
    type: 'file',
    label: 'Link Tuition Express Form (add pdf)',
    required: false,
  },
  {
    id: 'q-bill-audit-1',
    subcategoryId: 'finance-billing-account-audit',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'q-bill-audit-2',
    subcategoryId: 'finance-billing-account-audit',
    type: 'text',
    label: 'Child Name',
    required: true,
  },
  {
    id: 'q-bill-audit-3',
    subcategoryId: 'finance-billing-account-audit',
    type: 'text',
    label: 'Parent Name',
    required: true,
  },
  {
    id: 'q-bill-audit-4',
    subcategoryId: 'finance-billing-account-audit',
    type: 'text',
    label: 'Dates For Audits',
    required: true,
  },
  {
    id: 'q-bill-audit-5',
    subcategoryId: 'finance-billing-account-audit',
    type: 'textarea',
    label: 'Reason for Audit',
    required: true,
  },
  {
    id: 'q-bill-audit-6',
    subcategoryId: 'finance-billing-account-audit',
    type: 'file',
    label: 'Select a file',
    required: false,
  },
  {
    id: 'q-pay-work-1',
    subcategoryId: 'finance-paycheck-workforce-assistance',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'q-pay-work-2',
    subcategoryId: 'finance-paycheck-workforce-assistance',
    type: 'text',
    label: 'Staff Legal First Name',
    required: true,
  },
  {
    id: 'q-pay-work-3',
    subcategoryId: 'finance-paycheck-workforce-assistance',
    type: 'text',
    label: 'Staff Legal Last Name',
    required: true,
  },
  {
    id: 'q-pay-work-4',
    subcategoryId: 'finance-paycheck-workforce-assistance',
    type: 'text',
    label: 'Staff Email',
    required: true,
  },
  {
    id: 'q-pay-work-5',
    subcategoryId: 'finance-paycheck-workforce-assistance',
    type: 'textarea',
    label: 'Description',
    required: true,
  },
  {
    id: 'q-pay-work-6',
    subcategoryId: 'finance-paycheck-workforce-assistance',
    type: 'file',
    label: 'Select a file',
    required: false,
  },
  {
    id: 'q-pay-err-1',
    subcategoryId: 'finance-paycheck-error',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'q-pay-err-2',
    subcategoryId: 'finance-paycheck-error',
    type: 'text',
    label: 'Staff Legal First Name',
    required: true,
  },
  {
    id: 'q-pay-err-3',
    subcategoryId: 'finance-paycheck-error',
    type: 'text',
    label: 'Staff Legal Last Name',
    required: true,
  },
  {
    id: 'q-pay-err-4',
    subcategoryId: 'finance-paycheck-error',
    type: 'textarea',
    label: 'What Was The Paycheck Error',
    required: true,
  },
  {
    id: 'q-pay-err-5',
    subcategoryId: 'finance-paycheck-error',
    type: 'file',
    label: 'Submit Updated Timecard (upload PDF)',
    required: false,
  },
  {
    id: 'q-pay-q-1',
    subcategoryId: 'finance-paycheck-questions',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'q-pay-q-2',
    subcategoryId: 'finance-paycheck-questions',
    type: 'text',
    label: 'Staff Legal First Name',
    required: true,
  },
  {
    id: 'q-pay-q-3',
    subcategoryId: 'finance-paycheck-questions',
    type: 'text',
    label: 'Staff Legal Last Name',
    required: true,
  },
  {
    id: 'q-pay-q-4',
    subcategoryId: 'finance-paycheck-questions',
    type: 'textarea',
    label: 'Question About Paycheck',
    required: true,
  },
  {
    id: 'q-pay-q-5',
    subcategoryId: 'finance-paycheck-questions',
    type: 'file',
    label: 'Select a file',
    required: false,
  },
];
